'use client';

import { LottieAnimation } from '@/components/ui';

type FireworksProps = {
  showFireworks: boolean[];
};

export const Fireworks = ({ showFireworks }: FireworksProps) => {
  if (!showFireworks || showFireworks.length < 2) {
    return null;
  }

  const showFirst = showFireworks[0] === true;
  const showSecond = showFireworks[1] === true;

  if (!showFirst && !showSecond) {
    return null;
  }

  return (
    <div className="absolute inset-0 flex items-end justify-center pointer-events-none z-50 overflow-visible">
      {showFirst && (
        <div
          key="firework-1"
          className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-full"
        >
          <LottieAnimation
            loop={false}
            src="/animations/fireworks.json"
            className="w-full h-full object-cover"
          />
        </div>
      )}
      {showSecond && (
        <div
          key="firework-2"
          className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full h-full"
        >
          <LottieAnimation
            loop={false}
            src="/animations/fireworks.json"
            className="w-full h-full object-cover"
          />
        </div>
      )}
    </div>
  );
};
